import { createAction } from "./actionHelper";
import { HYDRATE } from "../constants";

const hydrateAction = (state: { [moduleId: string]: any }) =>
  createAction(HYDRATE, state);

export type HydrateAction = ReturnType<typeof hydrateAction>;

export default hydrateAction;
